export default {
    person: {
        wzTZ: 'King Honor Backstage-Management-System',
        wzKF: 'Kontaktinformationen für Entwickler',
        QQ1: 'QQ Nummer 1',
        QQ2: 'QQ Nummer 2',
        mailbox: 'Briefkasten',
        browser: 'Browser',
        RecommendedUse: 'Empfohlene Verwendung',
        mattersNeedingAttention: 'Notizen',
        mattersNeedingAttention1: 'Es ist verboten, das Original zu verändern und für kommerzielle Zwecke zu verwenden',
        mattersNeedingAttention2: 'Diese Seite ist nur für Entwickler gedacht, um zu kommunizieren und zu lernen',
        version: 'Versionsnummer',
    },
    home:{
        wzry:"einloggen",
        game:'einloggen',
        account:'Bitte geben Sie die Kontonummer ein',
        password:'Bitte geben Sie ein Passwort ein',
        remember:'Merken Sie sich das Passwort'
    },
    Login:{
        name:"Willkommen",
        register:"einschreiben",
        logon:"einloggen",
        ZY:"Die Herbstfärbung ist leicht kühl und dunkel",
        ReSelect:"Erneut"
    }
};